import { render, staticRenderFns } from "./forsta-individual-question-duration-script-widget.vue?vue&type=template&id=2c002f55"
import script from "./forsta-individual-question-duration-script-widget.vue?vue&type=script&lang=js"
export * from "./forsta-individual-question-duration-script-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports